import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 注册i18n实例并引入语言文件
const i18n = new VueI18n({
  locale: 'zh-en',
  fallbackLocale: 'zh-en',
  messages: {
    'zh-cn': require('@/assets/languages/zh_cn.json'),
    'zh-en': require('@/assets/languages/zh_en.json'),
    'en-us': require('@/assets/languages/en_us.json'),
    'zh-tr': require('@/assets/languages/zh_tr.json'),
    'mongolian': require('@/assets/languages/mongolian.json'),
    'vi': require('@/assets/languages/vi.json'),
    'ar': require('@/assets/languages/ar.json'),
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/assets/i18n/index.js